import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { HeadingDisplay, Grid } from '@warrenbrasil/nebraska-web';
import { AllocationChartLegend } from '@/modules/wealth/components/AllocationChartLegend';
import { BarChart } from '@/modules/common/components/charts/v2/BarChart';
import { Money } from '@/modules/common/components/Money';

import { IPlannedChart } from '@/modules/wealth/services/portfolio-allocation';

interface Props {
  plannedChart: IPlannedChart;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlannedChart',
  props: {
    plannedChart: null
  },
  setup(__props: any) {

const { plannedChart } = __props as {
  plannedChart: IPlannedChart;
};



const headingData = ref({
  head: 'Patrimônio da carteira',
  value: plannedChart.totalBalance.formatted
});

const legendData = computed(() => {
  return plannedChart.planned.map((item, index) => {
    return {
      color: item.color,
      leftTitle: item.type,
      leftSubtitle: `${plannedChart.applied[index].percent.formatted} (A)`,
      rightTitle: '',
      rightSubtitle: `${item.percent.formatted} ${item.sufix}`
    };
  });
});

const series = computed(() => {
  return [
    {
      type: 'column',
      name: 'Atual',
      data: plannedChart.applied.map(item => {
        return {
          y: item.percent.value,
          custom: {
            head: `${item.type} atual`,
            value: item.percent.formatted
          }
        };
      }),
      colors: plannedChart.applied.map(item => item.color),
      ...serieConfig('A'),
      point: {
        events: {
          mouseOver: function () {
            headingData.value = this.custom;
          },
          mouseOut: function () {
            headingData.value = {
              head: 'Patrimônio da carteira',
              value: plannedChart.totalBalance.formatted
            };
          }
        }
      }
    },
    {
      type: 'column',
      name: 'Planejada',
      data: plannedChart.planned.map(item => {
        return {
          y: item.percent.value,
          custom: {
            head: `${item.type} planejada`,
            value: item.percent.formatted
          }
        };
      }),
      colors: plannedChart.planned.map(item => item.color),
      ...serieConfig('P'),
      point: {
        events: {
          mouseOver: function () {
            headingData.value = this.custom;
          },
          mouseOut: function () {
            headingData.value = {
              head: 'Patrimônio da carteira',
              value: plannedChart.totalBalance.formatted
            };
          }
        }
      }
    }
  ];
});

function serieConfig(format: string) {
  return {
    colorByPoint: true,
    pointPadding: 0.03,
    groupPadding: 0.05,
    maxPointWidth: 125,
    borderRadius: 5,
    inactiveOtherPoints: true,
    cursor: 'pointer',
    dataLabels: {
      enabled: true,
      format,
      style: {
        color: NebraskaColors.elementPrimary,
        fontSize: '13px',
        fontFamily: 'var(--font-text)'
      }
    }
  };
}

return { __sfc: true,headingData, legendData, series, serieConfig, HeadingDisplay, Grid, AllocationChartLegend, BarChart, Money }
}

})